<template>
  <div
    class="data-extraction-panel d-flex flex-column flex-grow-1 overflow-hidden"
  >
    <v-row
      no-gutters
      class="d-flex flex-column flex-grow-1 flex-nowrap overflow-hidden"
    >
      <div class="overflow-auto d-flex flex-column">
        <extraction-field-group
          v-for="(fieldGroup, i) in fieldGroups"
          :key="fieldGroup.id"
          :header-field="fieldGroup.header"
          :data-fields="fieldGroup.fields"
          :class="{ 'bottom-border': i < fieldGroups.length - 1 }"
          :disabled="disabled"
          :report="report"
          :collapse-all="collapseAll"
          @input="onFieldValueChange"
        />
      </div>
    </v-row>
  </div>
</template>

<script>
import ExtractionFieldGroup from './ExtractionFieldGroup';
import {
  DataExtractionFieldBase,
  DataExtractionReport,
} from '@/models';
import { splitFieldListIntoGroups } from '@/modules/dataExtractionFieldHelpers';
import { typeHelpers } from '@/modules';

export default {
  name: 'DataExtractionPanel',
  components: { ExtractionFieldGroup },
  props: {
    report: {
      type: DataExtractionReport,
      required: true,
    },
    fields: {
      type: Array,
      default: () => [],
      validator: (field) =>
        typeHelpers.isArrayOfType(field, DataExtractionFieldBase),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showSubmit: {
      type: Boolean,
      default: false,
    },
    collapseAll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldGroups() {
      return splitFieldListIntoGroups(this.fields);
    },
  },
  methods: {
    onFieldValueChange(fieldValue) {
      this.$emit('field-value-change', fieldValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.bottom-border {
  border-bottom: 1px solid map-get($grey, 'lighten-2') !important;
}
</style>
